import { convertTextToCent } from 'src/Helpers/CurrencyHelpers'
import IGenericError from 'src/Models/Server/IGenericError'
import { ICreateEventTicketRequest } from 'src/Models/Server/Request/EventTicket/ICreateEventTicketRequest'
import { IEditEventTicketRequest } from 'src/Models/Server/Request/EventTicket/IEditEventTicketRequest'
import { IEventTicketEditVTO } from 'src/Models/Server/Response/Event/IEventTicketEditVTO'
import { IEventVTO } from 'src/Models/Server/Response/Event/IEventVTO'
import { IExceptionError } from 'src/Models/Server/Response/Exception/ExceptionError'
import EventController from 'src/Services/ToprCoreApi/Axios/Controllers/EventController'
import { appUiStore } from 'src/Stores/AppUiStore'
import { IEventFormValues } from '../Form/Reducer'

export interface IState {
  event?: IEventVTO
  eventTicketEdit?: IEventTicketEditVTO
  isSubmitting: boolean
}

export const initialState: IState = {
  isSubmitting: false,
  event: undefined,
  eventTicketEdit: undefined,
}

export type Actions =
  | {
      type: 'setIsSubmitting'
      isSubmitting: boolean
    }
  | {
      type: 'initialized'
      event: IEventVTO
      eventTicketEdit: IEventTicketEditVTO
    }

export const reducer = (state: IState, action: Actions): IState => {
  switch (action.type) {
    case 'initialized':
      return {
        ...state,
        event: action.event,
        eventTicketEdit: action.eventTicketEdit,
      }
    case 'setIsSubmitting':
      return {
        ...state,
        isSubmitting: action.isSubmitting,
      }
    default:
      throw new Error('Invalid Reducer Action')
  }
}

export const reducerActions = (
  state: IState,
  dispatch: (action: Actions) => void
) => {
  return {
    initialize: (eventId: string, eventTicketId: string) => {
      Promise.all([
        EventController.GetEvent(eventId),
        EventController.GetEventTicketEdit(eventTicketId),
      ])
        .then((values) => {
          dispatch({
            type: 'initialized',
            event: values[0],
            eventTicketEdit: values[1],
          })
        })
        .catch((error: IExceptionError) => {
          appUiStore.ShowError(error)
        })
    },

    save: (eventTicketId: string, data: IEventFormValues) => {
      const request: IEditEventTicketRequest = {
        EventTicketId: eventTicketId,
        Name: data.Name,
        OnSale: data.OnSale,
        Price: convertTextToCent(data.Price.toString()),
      }

      dispatch({ type: 'setIsSubmitting', isSubmitting: true })
      EventController.EventTicketEdit(request)
        .then(() => {
          history.back()
          dispatch({ type: 'setIsSubmitting', isSubmitting: false })
        })
        .catch((error: IGenericError) => {
          appUiStore.ShowError(error)
          dispatch({ type: 'setIsSubmitting', isSubmitting: false })
        })
    },
  }
}
